import { createElementFromHTML, initClassParams } from "./functions";

export default class GDPR {
    constructor(storage, params = {}) {
        this.$el = null;
        this.storage = storage;
        this.params = initClassParams(this.defaultParams(), params);
    }

    defaultParams() {
        return {
            storageKey: "gdpr",
            translate: {
                button: "OK",
                text: 'Vi använder cookies för att ge dig bästa möjliga upplevelse av vår hemsida. <a href="/integritetspolicy-anvandarvillkor/">Integritetspolicy</a>',
            },
        };
    }

    initListeners(el) {
        el.addEventListener("click", () => {
            this.accept();
            this.hide();
        });
    }

    show() {
        this.$el = document.body.appendChild(this.template());
        setTimeout(() => {
            this.$el.style.bottom = "0px";
        }, 1000);
        this.initListeners(this.$el);
    }

    hide() {
        if (this.$el) {
            this.$el.style.bottom = "";
            setTimeout(() => {
                this.$el.remove();
                this.$el = null;
            }, 1000);
        }
    }

    isAccepted() {
        return this.storage.get(this.params.storageKey) || false;
    }

    accept() {
        this.storage.set(this.params.storageKey, true);
    }

    template() {
        return createElementFromHTML(
            `<div class="gdpr"><p>${this.params.translate.text}</p><button class="button button-default">${this.params.translate.button}</button></div>`
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/libs/GDPR.js